// test1395
(1395 && 0);
